import './home.css'
import {Slider} from "./slider/slider";

import {Results} from "./widgets/results";
import {Races} from "./widgets/races";
import {homeHippodrome, homeHippodromeSubject} from "../../store/misc.store";
import React, {useEffect, useState} from "react";
import {isLuckyGamesActive, useForceUpdate} from "../../services/misc.functions";
import {HippodromeWidget} from "../../shared/hippodrome/hippodrome";
import {VerifyEmail} from "./verify.email";
import paths from "../../paths";
import {useNavigate} from "react-router-dom";
import {isMobile} from "../../App";
import {Possibles} from "./widgets/possibles";
import {Agf} from "./widgets/agf";
import {NotRunningHorses} from "./widgets/not.running.horses";
import {ChangedJockeys} from "./widgets/changed.jockeys";
import {HippodromeCards} from "./widgets/hippodrome.cards";
import {DailyResults} from "./widgets/daily.results";
import {PopularGames} from "./widgets/popular.games";
import {useAvailableFOBHippodromes, useAvailableHippodromes} from "features/bulletin/bulletin.store";
import canliIzleIcon from "../../assets/icons/home/canli-izle.png";
import kampanyalarIcon from "../../assets/icons/home/kampanyalar.png";
import basKazanIcon from "../../assets/icons/home/bas-kazan.png";
import sonuclarIcon from "../../assets/icons/home/sonuclar.png";
import hazirKuponlarIcon from "../../assets/icons/home/hazir-kuponlar.png";
import yazarlarIcon from "../../assets/icons/home/yazarlar.png";
import programIcon from "../../assets/icons/home/program.png";
import kosmayanAtlarIcon from "../../assets/icons/home/kosmayan-atlar.png";
import jokeyDegisikligiIcon from "../../assets/icons/home/jokey-degisikligi.png";
import uzunVadeliIcon from "../../assets/icons/home/uzun-vadeli.png";

export function Home() {
    const availableHippodromes = useAvailableHippodromes();
    const availableFobHippodromes = useAvailableFOBHippodromes();
    const navigate = useNavigate();
    const forceUpdate = useForceUpdate();
    const [selectedTab, setSelectedTab] = useState<string>("program");
    const shortcuts = [
        {label: "Canlı İzle", icon: canliIzleIcon, url: paths.stream.url},
        {label: "Kampanyalar", icon: kampanyalarIcon, url: paths.campaigns.url},
        ...(isLuckyGamesActive() ? [{label: "Bas Kazan", icon: basKazanIcon, url: paths.games.url, highlight: true}] : []),
        {label: "Yazarlar", icon: yazarlarIcon, url: paths.tipsterComments.url},
        {label: "Hazır Kuponlar", icon: hazirKuponlarIcon, url: paths.tipsterCoupons.url},
        {label: "Uzun Vadeli", icon: uzunVadeliIcon, url: paths.bettingLongterm.url},
        {label: "Koşmayan Atlar", icon: kosmayanAtlarIcon, url: paths.notRunningHorses.url},
        {label: "Jokey Değişikliği", icon: jokeyDegisikligiIcon, url: paths.jockeyChanges.url},
        {label: "Program", icon: programIcon, url: paths.program.url},
        {label: "Sonuçlar", icon: sonuclarIcon, url: paths.results.url},
    ];

    useEffect(() => {
        let homeHippodromeSubject_subscription = homeHippodromeSubject.subscribe((res: any) => {
            forceUpdate();
        })

        return () => {
            homeHippodromeSubject_subscription.unsubscribe();
        }
    }, []);

    if (isMobile) {
        return <div className={"home-mobile"}>
            <div className={"home-banner"}>
                <Slider/>
            </div>

            <div className={"home-segments"}>
                <button onClick={() => {
                    const target = homeHippodrome?.status ? homeHippodrome : availableHippodromes[0];
                    if (target) {
                        navigate(`${paths.betting.url}/${target.keyword.toLowerCase()}${target._id}`);
                    }
                }}>Müşterek
                </button>
                <button onClick={() => {
                    if (homeHippodrome) {
                        navigate(`${paths.bettingFob.url}`);
                    } else {
                        navigate(`${paths.bettingFob.url}/${availableFobHippodromes[0].keyword.toLowerCase()}${availableFobHippodromes[0]._id}`);
                    }
                }}>Sabit İhtimalli
                </button>
                {isLuckyGamesActive()
                    ? <button className={"accent"} onClick={() => navigate(paths.games.url)}>
                        <span className={"home-badge"}>YENİ</span>
                        Bas Kazan
                    </button>
                    : <button onClick={() => navigate(paths.bettingLongterm.url)}>
                        <span className={"home-badge"}>YENİ</span>
                        Uzun Vadeli
                    </button>}
            </div>

            <div className={"home-switch"}>
                <button className={selectedTab === "program" ? "active" : ""}
                        onClick={() => setSelectedTab("program")}>Yarış Programı
                </button>
                <button className={selectedTab === "results" ? "active" : ""}
                        onClick={() => setSelectedTab("results")}>Sonuçlar
                </button>
            </div>

            {selectedTab === "program" ? <HippodromeCards/> : <DailyResults/>}

            <div className={"home-shortcuts"}>
                {[shortcuts.slice(0, 6), shortcuts.slice(6)].filter((row) => row.length > 0).map((row, rowIndex) => {
                    return <div key={`home-shortcut-row-${rowIndex}`}
                                className={`home-shortcut-grid${row.length > 3 && rowIndex > 0 ? " is-compact" : ""}`}
                                style={rowIndex > 0 ? {gridTemplateColumns: `repeat(${row.length}, 1fr)`} : undefined}>
                        {row.map((shortcut: any, index: number) => {
                            return <button key={`home-shortcut-${rowIndex}-${index}`}
                                           className={shortcut.highlight ? "highlight" : ""}
                                           onClick={() => navigate(shortcut.url)}>
                                {shortcut.highlight && <span className={"home-badge"}>YENİ</span>}
                                <img src={shortcut.icon} alt={""}/>
                                {shortcut.label}
                            </button>
                        })}
                    </div>
                })}
            </div>

            {isLuckyGamesActive() && <PopularGames/>}

            <VerifyEmail></VerifyEmail>
        </div>
    } else {
        return <div>
            <div className={"bg-green"}>
                <div className={"container py-4"}>
                    <Slider/>
                </div>
            </div>

            <HippodromeWidget/>

            <div className={"container"}>
                <div className={"home-grid"}>

                    <Possibles hippodrome={homeHippodrome}/>

                    <Agf hippodrome={homeHippodrome}/>

                    <Results/>

                    <Races/>

                    <NotRunningHorses/>

                    <ChangedJockeys/>

                </div>
            </div>
            <VerifyEmail></VerifyEmail>

        </div>

    }
}
